import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdminSessionContainer from './AdminSessionContainer';
import {Link} from 'react-router-dom';
import * as firebase from 'firebase';
import 'intro.js/introjs.css';
import { Steps } from 'intro.js-react';
//gets user props from app.js

//This component is the admin homepage
//and renders the admin session Container
//as well as quick start,custom session,
//and manage admin buttons

class AdminHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stepsEnabled: false,
      initialStep: 0,
      steps: [
        {
          element: '.network',
          intro: 'This button creates a networked session',
        },
        {
          element: '.solitare',
          intro: 'This button creates a solo session',
        },
        {
          element: '.title',
          intro: 'This is a sessions title'
        },
        {
          element: '.join',
          intro: 'You can join a session here(if its not solo)'
        },
        {
          element: '.rank',
          intro: 'Here you can see a live feed of how players are doing'
        },
        {
          element: '.edit',
          intro: 'Here you can edit the title of a session you created'
        },
        {
          element: '.delete',
          intro: 'Here you can delete a session you created'
        },
        {
          element: '.solo',
          intro: 'Here is where you can toggle whether a session you created is solo or networked'
        },
      ]
    }
    this.networkSession = this.networkSession.bind(this);
    this.soloSession = this.soloSession.bind(this)
  }



  //this function generates a quick session with default parameters
  networkSession() {
    //TODO: change these for a network session
    const sessionRef = firebase.database().ref().child(this.props.institution).child("Sessions");
    var newSessionRef = sessionRef.push();
    var timeCreated = new Date().toUTCString();
    var session = {
      //"Title": this.props.user.displayName + timeCreated,
      "UserCount": 0,
      "GameParams": {
        "StartPrice": "2100", //(this.state.StartPrice*100).toFixed(0),
        "msPerSec": 15,
        "numLiq": 100,
        "numInf": 50,
        "numMom": 50,
        "numPStar": 3,
        "FracOfDay": 1
      },
      "StartSim": {
        "SessionID":newSessionRef.key
      }
    }
    newSessionRef.set(session);
    newSessionRef.child("Info").set(
      {
      "Title": this.props.user.displayName + " " + timeCreated,
      "Creator": this.props.user.uid,
      "Solo": false
    })
    // console.log("called");
    // let adminRef = firebase.database().ref().child("Admin");
    // let newadminRef = adminRef.push();
    // console.log(newadminRef);
    // let admin = {
    //   "name": "jorss"
    // };
    // console.log(admin);
    // newadminRef.set(admin);
  }

  soloSession() {
    const sessionRef = firebase.database().ref().child(this.props.institution).child("Sessions");
    var newSessionRef = sessionRef.push();
    var timeCreated = new Date().toUTCString();
    var session = {
      //"Title": this.props.user.displayName + timeCreated,
      "UserCount": 0,
      "GameParams": {
        "StartPrice": "2100", //(this.state.StartPrice*100).toFixed(0),
        "msPerSec": 15,
        "numLiq": 100,
        "numInf": 50,
        "numMom": 50,
        "numPStar": 3,
        "FracOfDay": 1
      },
      "StartSim": {
        "SessionID":newSessionRef.key
      }
    }
    newSessionRef.set(session);
    newSessionRef.child("Info").set(
      {
      "Title": this.props.user.displayName + " " + timeCreated,
      "Creator": this.props.user.uid,
      "Solo": true
    })
    // console.log("called");
    // let adminRef = firebase.database().ref().child("Admin");
    // let newadminRef = adminRef.push();
    // console.log(newadminRef);
    // let admin = {
    //   "name": "jorss"
    // };
    // console.log(admin);
    // newadminRef.set(admin);
  }

  componentDidMount() {

  }

  startIntro() {
    this.setState({
      stepsEnabled: true
    })
  }

  render() {
    const { stepsEnabled, steps, initialStep } = this.state;
    const style = {
      marginTop: '5px',
      marginLeft: '20px'
    };

    return (
      <div>
        <Steps
          enabled={stepsEnabled}
          steps={steps}
          initialStep={initialStep}
          onExit={function(){}}
        />


      <div>
        <Link to="/Home"><button onClick={this.networkSession} style={style} className="btn btn-primary network">Network Session</button></Link>
        <Link to="/Home"><button onClick={this.soloSession} style={style} className="btn btn-primary solitare">Solitare Session</button></Link>
        {/* <Link to="/CreateSession"><button style={style} className="btn btn-primary custom">Custom Session</button></Link> */}
        <button className="btn btn-primary" style={style} onClick={this.startIntro.bind(this)}>Homepage Tutorial</button>
        <Link to="/Tutorial"><button  style={style} className="btn btn-primary simTut">Sim Tutorial</button></Link>
        {/* <Link to="/ManageAdmin"><button style={{'float':'right','marginTop':'5px'}} className="btn btn-primary google">Manage Admins</button></Link> */}
        <AdminSessionContainer user={this.props.user} institution={this.props.institution} />
      </div>
    </div>
    );
  }
}

AdminHome.propTypes = {
  user: PropTypes.object,
  authed: PropTypes.bool
};

export default AdminHome;



// WEBPACK FOOTER //
// ./src/components/Admin/AdminHome.js